import GridDialog from './gridDialog.vue';

GridDialog.install = function (Vue) {
    Vue.component(GridDialog.name, GridDialog);
};

export default GridDialog;